export class SearchForm {

  constructor(
    public id?: string,
    public userId?: string,
    public name?: string,
    public filterCondition?: string,
    public searchOptions?: SearchFormOptionItem[],
  ) {
  }
}


export class SearchFormOptionItem {

  constructor(
    public order?: number,
    public group?: string,
    public field?: string,
    public operator?: string,
    public values?: string[]
  ) {
  }
}